import React from 'react';
import { movdTokens } from './movdTokens.js';

const palette = {
  success: { bg: movdTokens.color.state.successSurface, fg: movdTokens.color.state.success },
  error: { bg: movdTokens.color.state.errorSurface, fg: movdTokens.color.state.error },
  warning: { bg: movdTokens.color.state.warningSurface, fg: movdTokens.color.state.warning },
  info: { bg: movdTokens.color.state.disabledSurface, fg: movdTokens.color.content.secondary },
};

// Shared inline notice/alert — replaces MUI <Alert> across customer pages.
export default function MovdNotice({ tone = 'info', children, style }) {
  const colors = palette[tone] || palette.info;
  return (
    <div role={tone === 'error' ? 'alert' : 'status'} style={{ background: colors.bg, color: colors.fg, borderRadius: 10, padding: '12px 16px', fontSize: 14, fontWeight: 600, lineHeight: 1.5, ...style }}>
      {children}
    </div>
  );
}
